<span class="mr-4 notify">
  <img src="assets/images/notification.svg" alt="">
</span>
